module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "compose"
  }, [_c('el-input', {
    attrs: {
      "type": "textarea",
      "autosize": "",
      "placeholder": "Subject:"
    },
    model: {
      value: (_vm.subject),
      callback: function($$v) {
        _vm.subject = $$v
      },
      expression: "subject"
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin": "20px 0"
    }
  }), _vm._v(" "), _c('el-input', {
    attrs: {
      "type": "textarea",
      "autosize": {
        minRows: 37,
        maxRows: 70
      },
      "placeholder": "Text:"
    },
    model: {
      value: (_vm.body),
      callback: function($$v) {
        _vm.body = $$v
      },
      expression: "body"
    }
  }), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('div', {
    staticClass: "grid-content bg-purple-dark"
  })]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "success"
    },
    on: {
      "click": _vm.sendEmail
    }
  }, [_vm._v("Send")])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0df34286","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/email/EmailCompose.vue
// module id = 276
// module chunks = 1